// extracted by mini-css-extract-plugin
module.exports = {"ErrorInformation":"style_ErrorInformation__1yfPS","Information":"style_Information__27AB5","Redirect":"style_Redirect__2sZNO"};